/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import cep from 'cep-promise';
import InputMask from 'react-input-mask';

import Map from 'components/Map';
import Paper from 'components/Paper';
import TextField from 'components/TextField';
import Button from 'components/Button';
import Images from 'assets/img';
import ProvidersActions from 'store/ducks/providers';
import { Input, Label } from 'components/TextInput/styles';
import { locationByIP, locationByAddress } from 'services/getLocations';
import { InputAdornment } from '@material-ui/core';
import { schema } from '../components/Modal/schemaValidation';

import {
  Container,
  WrapperBody,
  WrapperContent,
  WrapperBottom,
  BottomText,
  Line,
  WrapperInput,
  InputRow,
  Loading,
  Center,
  StepperMUI,
  BoxMap,
  HeaderButtons,
  SectionTitle,
  Row,
  Column,
} from './styles';


// Componente wrapper para InputMask que preserva a posição do cursor (igual ao usado em ViagemForm)
const MaskedInput = ({ mask, value, onChange, onBlur, children, ...props }) => {
  const handleChange = (e) => {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    const oldValue = value || '';
    const newValue = input.value || '';

    onChange(e);

    setTimeout(() => {
      if (input && input.setSelectionRange) {
        const lengthDiff = newValue.length - oldValue.length;
        let newPosition = cursorPosition;

        if (lengthDiff > 0) {
          newPosition = Math.min(cursorPosition + lengthDiff, newValue.length);
        } else if (lengthDiff < 0) {
          newPosition = Math.max(0, cursorPosition + lengthDiff);
        }

        newPosition = Math.min(newPosition, newValue.length);
        input.setSelectionRange(newPosition, newPosition);
      }
    }, 0);
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <InputMask
      {...props}
      mask={mask}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      alwaysShowMask={false}
      maskChar={null}
    >
      {children}
    </InputMask>
  );
};

const key = process.env.REACT_APP_MAPS_KEY;
const hasValidKey = key && key !== 'undefined' && key.trim() !== '';

function getSteps() {
  return ['DADOS DA EMPRESA/RESPONSÁVEL', 'ENDEREÇO DA EMPRESA'];
}

function ProviderForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const { providers } = useSelector((state) => state.providers);
  const isEdit = !!id;
  const formikRef = useRef(null);

  const provider = isEdit ? providers.find((p) => p.id === id) : null;

  const [position, setPosition] = useState({
    latitude: 0,
    longitude: 0,
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [formikValues, setFormikValues] = useState({});
  const steps = getSteps();

  const [fullAddress, setFullAddress] = useState({
    cep: '',
    street: '',
    neighborhood: '',
    city: '',
    state: '',
  });

  const formik = useFormik({
    innerRef: formikRef,
    initialValues: {
      social_reason: provider?.social_reason || '',
      cnpj: provider?.cnpj || '',
      fantasy_name: provider?.fantasy_name || provider?.nome_fantasia || '',
      state_subscribe: provider?.state_subscribe || '',
      municipal_subscribe: provider?.municipal_subscribe || provider?.inscricao_municipal || '',
      taxpayer: provider?.taxpayer || 'Não',
      owner: provider?.owner || '',
      phone_ddd: provider?.phone_ddd || (provider?.phone ? provider.phone.replace(/\D/g, '').substring(0, 2) : ''),
      phone_number: provider?.phone_number || (provider?.phone ? provider.phone.replace(/\D/g, '').substring(2) : ''),
      email: provider?.email || '',
      zipcode: provider?.zipcode || '',
      address: provider?.address || '',
      number: provider?.number || '',
      complement: provider?.complement || '',
      neighborhood: provider?.neighborhood || '',
      city: provider?.city || '',
      city_code: provider?.city_code || provider?.municipio_codigo || '',
      state: provider?.state || '',
      rntrc: provider?.rntrc || '',
      lat: provider?.lat || '',
      lng: provider?.lng || '',
    },
    onSubmit: (values) => handleSubmitted(values),
    validationSchema: schema(),
    validateOnChange: true,
    isValidating: true,
    enableReinitialize: true,
  });

  useEffect(() => {
    dispatch(ProvidersActions.getProvidersRequest());
  }, [dispatch]);

  useEffect(() => {
    if (isEdit && provider) {
      formik.setValues({
        social_reason: provider.social_reason || '',
        cnpj: provider.cnpj || '',
        fantasy_name: provider.fantasy_name || provider.nome_fantasia || '',
        state_subscribe: provider.state_subscribe || '',
        municipal_subscribe: provider.municipal_subscribe || provider.inscricao_municipal || '',
        taxpayer: provider.taxpayer || 'Não',
        owner: provider.owner || '',
        phone_ddd: provider.phone_ddd || (provider.phone ? provider.phone.replace(/\D/g, '').substring(0, 2) : ''),
        phone_number: provider.phone_number || (provider.phone ? provider.phone.replace(/\D/g, '').substring(2) : ''),
        email: provider.email || '',
        zipcode: provider.zipcode || '',
        address: provider.address || '',
        number: provider.number || '',
        complement: provider.complement || '',
        neighborhood: provider.neighborhood || '',
        city: provider.city || '',
        city_code: provider.city_code || provider.municipio_codigo || '',
        state: provider.state || '',
        rntrc: provider.rntrc || '',
        lat: provider.lat || '',
        lng: provider.lng || '',
      });
      if (provider.lat) {
        setPosition({
          latitude: provider.lat,
          longitude: provider.lng,
        });
      }
      if (provider.zipcode) {
        setFullAddress({
          cep: provider.zipcode,
          street: provider.address || '',
          neighborhood: provider.neighborhood || '',
          city: provider.city || '',
          state: provider.state || '',
        });
      }
    }
  }, [provider, isEdit]);

  useEffect(() => {
    getInitialPosition('Brasil');
  }, []);

  const validate = (values) => {
    const errors = {};
    if (!values.social_reason) {
      errors.social_reason = 'Obrigatório';
    } else if (values.social_reason.length < 3) {
      errors.social_reason = 'Deve ser maior que 3 caracteres.';
    }

    if (!values.cnpj) {
      errors.cnpj = 'Obrigatório';
    } else if (values.cnpj.replace(/([^\d])+/gim, '').length < 14) {
      errors.cnpj = 'CNPJ incompleto.';
    }

    if (!values.state_subscribe) {
      errors.state_subscribe = 'Obrigatório';
    } else if (values.state_subscribe.replace(/([^\d])+/gim, '').length < 9) {
      errors.state_subscribe = 'Inscrição estadual incompleto.';
    }

    if (!values.owner) {
      errors.owner = 'Obrigatório';
    } else if (values.owner.length < 3) {
      errors.owner = 'Deve ser maior que 3 caracteres';
    }

    if (!values.phone_ddd) {
      errors.phone_ddd = 'Obrigatório';
    } else if (values.phone_ddd.replace(/([^\d])+/gim, '').length < 2) {
      errors.phone_ddd = 'DDD incompleto.';
    }

    if (!values.phone_number) {
      errors.phone_number = 'Obrigatório';
    } else if (values.phone_number.replace(/([^\d])+/gim, '').length < 8) {
      errors.phone_number = 'Número de telefone incompleto.';
    }

    if (!values.email) {
      errors.email = 'Obrigatório';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = 'E-mail inválido.';
    }

    if (!values.rntrc) {
      errors.rntrc = 'Obrigatório';
    } else if (values.rntrc.replace(/([^\d])+/gim, '').length !== 8) {
      errors.rntrc = 'RNTRC deve ter 8 dígitos.';
    }

    return errors;
  };

  // Função para converter nome do estado para sigla (caso necessário)
  const getStateSigla = (stateName) => {
    const estados = {
      'Acre': 'AC',
      'Alagoas': 'AL',
      'Amapá': 'AP',
      'Amazonas': 'AM',
      'Bahia': 'BA',
      'Ceará': 'CE',
      'Distrito Federal': 'DF',
      'Espírito Santo': 'ES',
      'Goiás': 'GO',
      'Goias': 'GO', // Variante sem acento
      'Maranhão': 'MA',
      'Mato Grosso': 'MT',
      'Mato Grosso do Sul': 'MS',
      'Minas Gerais': 'MG',
      'Pará': 'PA',
      'Paraíba': 'PB',
      'Paraná': 'PR',
      'Pernambuco': 'PE',
      'Piauí': 'PI',
      'Rio de Janeiro': 'RJ',
      'Rio Grande do Norte': 'RN',
      'Rio Grande do Sul': 'RS',
      'Rondônia': 'RO',
      'Roraima': 'RR',
      'Santa Catarina': 'SC',
      'São Paulo': 'SP',
      'Sergipe': 'SE',
      'Tocantins': 'TO',
    };
    
    // Se já for sigla (2 caracteres), retornar como está
    if (stateName && stateName.length === 2) {
      return stateName.toUpperCase();
    }
    
    // Converter nome para sigla
    return estados[stateName] || stateName;
  };

  function handleSubmitted(values) {
    console.log('📝 handleSubmitted chamado com valores:', values);
    
    // Limpar e preparar valores para envio
    const cleanedValues = { ...values };
    
    // Combinar DDD e telefone em um único campo phone (para compatibilidade)
    if (cleanedValues.phone_ddd && cleanedValues.phone_number) {
      const phoneClean = cleanedValues.phone_ddd.replace(/\D/g, '') + cleanedValues.phone_number.replace(/\D/g, '');
      cleanedValues.phone = phoneClean;
    }
    // Remover campos separados após combinar
    delete cleanedValues.phone_ddd;
    delete cleanedValues.phone_number;
    
    // Converter estado para sigla se necessário (mas manter o valor original se a migration já foi executada)
    if (cleanedValues.state && cleanedValues.state.length > 2) {
      // Se o estado tiver mais de 2 caracteres, pode ser nome completo
      // Por enquanto, vamos manter o nome completo (após a migration, o campo aceita até 50 caracteres)
      // Se preferir usar sigla, descomente a linha abaixo:
      // cleanedValues.state = getStateSigla(cleanedValues.state);
    } else if (cleanedValues.state) {
      // Garantir que siglas estejam em maiúsculas
      cleanedValues.state = cleanedValues.state.toUpperCase();
    }
    
    // Remover campos vazios (strings vazias), mas manter campos numéricos válidos
    Object.keys(cleanedValues).forEach(key => {
      const value = cleanedValues[key];
      if (value === '' || value === null || value === undefined) {
        // Manter apenas campos numéricos que podem ser 0 ou vazios mas são válidos
        if (key !== 'number' && key !== 'status') {
          delete cleanedValues[key];
        } else if (key === 'number' && value === '') {
          // Se number estiver vazio, remover
          delete cleanedValues[key];
        }
      }
    });
    
    // Converter lat e lng para números se existirem e forem válidos
    if (cleanedValues.lat !== undefined && cleanedValues.lat !== '' && cleanedValues.lat !== null) {
      const latNum = parseFloat(cleanedValues.lat);
      if (!isNaN(latNum)) {
        cleanedValues.lat = latNum;
      } else {
        delete cleanedValues.lat;
      }
    } else {
      delete cleanedValues.lat;
    }
    
    if (cleanedValues.lng !== undefined && cleanedValues.lng !== '' && cleanedValues.lng !== null) {
      const lngNum = parseFloat(cleanedValues.lng);
      if (!isNaN(lngNum)) {
        cleanedValues.lng = lngNum;
      } else {
        delete cleanedValues.lng;
      }
    } else {
      delete cleanedValues.lng;
    }
    
    console.log('📤 Dados preparados para envio:', cleanedValues);
    console.log('🔄 Modo:', isEdit ? 'Edição' : 'Criação');
    
    try {
      if (isEdit) {
        console.log('📝 Atualizando provider ID:', id);
        dispatch(
          ProvidersActions.updateProviderRequest(
            { ...cleanedValues, id },
            () => {
              console.log('✅ Provider atualizado com sucesso, redirecionando...');
              history.push('/providers');
            }
          )
        );
      } else {
        console.log('➕ Criando novo provider');
        dispatch(ProvidersActions.addProviderRequest(cleanedValues, () => {
          console.log('✅ Provider criado com sucesso, redirecionando...');
          history.push('/providers');
        }));
      }
      // Não resetar o form imediatamente, deixar o callback fazer isso
      // formik.resetForm();
    } catch (error) {
      console.error('❌ Erro ao salvar provider:', error);
      alert('Erro ao salvar empresa. Verifique os dados e tente novamente.');
    }
  }

  const handleNext = () => {
    const values = formikRef.current?.values || formik?.values || {};
    const errors = validate(values);
    if (Object.keys(errors).length === 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setFormErrors({});
    } else {
      setFormErrors(errors);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getPosition = (address) => {
    locationByAddress(address).then((pos) => {
      if (pos.lat !== 0) {
        setPosition({
          latitude: pos.lat,
          longitude: pos.lng,
        });
        formik.setFieldValue('lat', pos.lat);
        formik.setFieldValue('lng', pos.lng);
      }
    });
  };

  const getInitialPosition = (address) => {
    locationByIP()
      .then((pos) => {
        if (pos.lat !== 0) {
          setPosition({
            latitude: pos.lat,
            longitude: pos.lng,
          });
        }
      })
      .catch(() => {
        locationByAddress(address).then((pos) => {
          if (pos.lat !== 0) {
            setPosition({
              latitude: pos.lat,
              longitude: pos.lng,
            });
          }
        });
      });
  };

  const getFormattedAddress = (address, number) => {
    let result = address.street;
    if (number && number.length) {
      result += `, ${number}`;
    }
    if (address.neighborhood.length) {
      result += `, ${address.neighborhood}`;
    }
    if (address.city.length) {
      result += `, ${address.city}`;
    }
    if (address.city.length) {
      result += ` - ${address.state}`;
    }
    return `${result}, Brasil`;
  };

  const handleCepChange = (cepRequested) => {
    const cepLimpo = cepRequested.replace(/\D/g, '');
    
    cep(cepLimpo)
      .then((cepResponse) => {
        const address = {
          cep: cepRequested,
          street: cepResponse.street,
          neighborhood: cepResponse.neighborhood,
          city: cepResponse.city,
          state: cepResponse.state,
        };
        setFullAddress(address);
        formik.setFieldValue(`address`, cepResponse.street);
        formik.setFieldValue(`neighborhood`, cepResponse.neighborhood);
        formik.setFieldValue(`city`, cepResponse.city);
        formik.setFieldValue(`state`, cepResponse.state);

        // Buscar código IBGE via API ViaCEP
        fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
          .then((viaCepResponse) => {
            if (viaCepResponse.ok) {
              return viaCepResponse.json();
            }
            return null;
          })
          .then((viaCepData) => {
            if (viaCepData && viaCepData.ibge) {
              formik.setFieldValue(`city_code`, viaCepData.ibge);
            }
          })
          .catch((error) => {
            console.warn('Não foi possível buscar código IBGE:', error);
          });

        getPosition(getFormattedAddress(address, formik.values.number));
      })
      .catch(() => {
        setFullAddress({
          cep: cepRequested,
          street: formik.values.address,
          neighborhood: formik.values.neighborhood,
          city: '',
          state: '',
        });
        formik.setFieldError(`zipcode`, 'CEP não encontrado');
      });
  };

  const handleAddressNumberChange = (addressNumber) => {
    if (addressNumber) {
      getPosition(getFormattedAddress(fullAddress, addressNumber));
    }
  };

  return (
    <Container>
      <Paper
        title={isEdit ? 'ATUALIZAR UMA EMPRESA' : 'CRIAR NOVA EMPRESA'}
        icon={Images.IconProviders}
        rightContent={
          <HeaderButtons>
            <Button
              label="Voltar"
              onClick={() => history.push('/providers')}
              type="button"
              margin="0 10px 0 0"
            />
            {activeStep === 1 ? (
              <Button
                label="Concluir"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('🔘 Botão Concluir clicado');
                  console.log('📋 Formik ref disponível:', !!formikRef.current);
                  console.log('📋 Formik disponível:', !!formik);
                  console.log('📋 Valores atuais:', formik?.values);
                  console.log('📋 Erros do formik:', formik?.errors);
                  console.log('📋 Touched:', formik?.touched);
                  
                  // O Formik valida automaticamente quando handleSubmit é chamado
                  // Tenta usar o ref primeiro, depois fallback para formik direto
                  if (formikRef.current && formikRef.current.handleSubmit) {
                    console.log('✅ Usando formikRef.current.handleSubmit');
                    formikRef.current.handleSubmit();
                  } else if (formik && formik.handleSubmit) {
                    console.log('✅ Usando formik.handleSubmit');
                    formik.handleSubmit();
                  } else {
                    console.error('❌ Nenhum método handleSubmit disponível');
                    alert('Erro: Não foi possível submeter o formulário. Tente recarregar a página.');
                  }
                }}
                type="button"
              />
            ) : (
              <Button
                label="Avançar"
                onClick={handleNext}
                type="button"
              />
            )}
          </HeaderButtons>
        }
      >
        <form onSubmit={formik.handleSubmit}>
          <WrapperBody>
            <WrapperContent>
              <StepperMUI activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {
                    color: '#FFF28D',
                  };
                  const labelProps = {};

                  return activeStep !== index ? (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps} />
                    </Step>
                  ) : (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </StepperMUI>

              <Line />

              {activeStep === 0 && (
                <>
                  <SectionTitle>Dados da Empresa/Responsável</SectionTitle>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Razão Social *"
                        name="social_reason"
                        placeholder="Digite aqui..."
                        error={!!formErrors.social_reason}
                        helperText={formErrors.social_reason}
                        value={formik.values.social_reason}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <MaskedInput
                        mask="99.999.999/9999-99"
                        name="cnpj"
                        value={formik.values.cnpj}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {(inputProps) => (
                          <TextField
                            {...inputProps}
                            label="CNPJ *"
                            error={!!formErrors.cnpj}
                            helperText={formErrors.cnpj}
                            fullWidth
                            color="secondary"
                          />
                        )}
                      </MaskedInput>
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Nome Fantasia"
                        name="fantasy_name"
                        placeholder="Digite aqui..."
                        value={formik.values.fantasy_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="Inscrição Estadual *"
                        name="state_subscribe"
                        placeholder="Digite aqui..."
                        error={!!formErrors.state_subscribe}
                        helperText={formErrors.state_subscribe}
                        value={formik.values.state_subscribe}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="Inscrição Municipal"
                        name="municipal_subscribe"
                        placeholder="Digite aqui..."
                        value={formik.values.municipal_subscribe}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <Label style={{ marginBottom: '8px' }}>Contribuinte</Label>
                      <RadioGroup
                        aria-label="taxpayer"
                        name="taxpayer"
                        value={formik.values.taxpayer}
                        onChange={formik.handleChange}
                        row
                        style={{ marginTop: '0' }}
                      >
                        <FormControlLabel
                          value="Sim"
                          control={<Radio size="small" />}
                          label={<span style={{ fontSize: '12px', fontFamily: 'Montserrat, sans-serif' }}>Sim</span>}
                        />
                        <FormControlLabel
                          value="Não"
                          control={<Radio size="small" />}
                          label={<span style={{ fontSize: '12px', fontFamily: 'Montserrat, sans-serif' }}>Não</span>}
                        />
                      </RadioGroup>
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="RNTRC *"
                        name="rntrc"
                        placeholder="Digite aqui..."
                        error={!!formErrors.rntrc}
                        helperText={formErrors.rntrc || 'Registro Nacional de Transportador de Carga (8 dígitos)'}
                        value={formik.values.rntrc}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                        inputProps={{ maxLength: 8 }}
                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Responsável *"
                        name="owner"
                        placeholder="Digite aqui..."
                        error={!!formErrors.owner}
                        helperText={formErrors.owner}
                        value={formik.values.owner}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="DDD Telefone *"
                        name="phone_ddd"
                        placeholder="Digite aqui..."
                        error={!!formErrors.phone_ddd}
                        helperText={formErrors.phone_ddd}
                        value={formik.values.phone_ddd}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                        inputProps={{ maxLength: 2 }}
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <MaskedInput
                        mask="99999-9999"
                        name="phone_number"
                        value={formik.values.phone_number}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {(inputProps) => (
                          <TextField
                            {...inputProps}
                            label="Telefone *"
                            error={!!formErrors.phone_number}
                            helperText={formErrors.phone_number}
                            fullWidth
                            color="secondary"
                            icon={
                              <InputAdornment position="start">
                                <img src={Images.IconFlagBrasil} alt="Brasil" style={{ height: '18px' }} />
                              </InputAdornment>
                            }
                          />
                        )}
                      </MaskedInput>
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="E-mail *"
                        name="email"
                        type="email"
                        placeholder="Digite aqui..."
                        error={!!formErrors.email}
                        helperText={formErrors.email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>
                  </InputRow>
                </>
              )}

              {activeStep === 1 && (
                <>
                  <SectionTitle>Endereço da Empresa</SectionTitle>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="CEP"
                        name="zipcode"
                        error={
                          formik.touched.zipcode &&
                          Boolean(formik.errors.zipcode)
                        }
                        helperText={formik.touched.zipcode && formik.errors.zipcode}
                        value={formik.values.zipcode}
                        onChange={formik.handleChange}
                        onBlur={(e) => handleCepChange(e.target.value)}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="Endereço"
                        name="address"
                        error={
                          formik.touched.address &&
                          Boolean(formik.errors.address)
                        }
                        helperText={formik.touched.address && formik.errors.address}
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="Nº"
                        name="number"
                        error={
                          !!formik.touched.number && !!formik.errors.number
                        }
                        helperText={formik.touched.number && formik.errors.number}
                        value={formik.values.number}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          formik.handleBlur(e);
                          handleAddressNumberChange(e.target.value);
                        }}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Complemento"
                        name="complement"
                        error={
                          formik.touched.complement &&
                          Boolean(formik.errors.complement)
                        }
                        helperText={formik.touched.complement && formik.errors.complement}
                        value={formik.values.complement}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="Bairro"
                        name="neighborhood"
                        error={
                          formik.touched.neighborhood &&
                          Boolean(formik.errors.neighborhood)
                        }
                        helperText={formik.touched.neighborhood && formik.errors.neighborhood}
                        value={formik.values.neighborhood}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Cidade"
                        name="city"
                        placeholder="Digite aqui..."
                        error={
                          formik.touched.city && Boolean(formik.errors.city)
                        }
                        helperText={formik.touched.city && formik.errors.city}
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>

                    <WrapperInput>
                      <TextField
                        label="Código IBGE do Município"
                        name="city_code"
                        placeholder="Digite aqui..."
                        value={formik.values.city_code}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                        helperText="Código IBGE do município"
                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="UF"
                        name="state"
                        error={
                          formik.touched.state && Boolean(formik.errors.state)
                        }
                        helperText={formik.touched.state && formik.errors.state}
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        select
                        fullWidth
                        color="secondary"
                      >
                        <option value="">Selecione</option>
                        <option value="AC">AC - Acre</option>
                        <option value="AL">AL - Alagoas</option>
                        <option value="AP">AP - Amapá</option>
                        <option value="AM">AM - Amazonas</option>
                        <option value="BA">BA - Bahia</option>
                        <option value="CE">CE - Ceará</option>
                        <option value="DF">DF - Distrito Federal</option>
                        <option value="ES">ES - Espírito Santo</option>
                        <option value="GO">GO - Goiás</option>
                        <option value="MA">MA - Maranhão</option>
                        <option value="MT">MT - Mato Grosso</option>
                        <option value="MS">MS - Mato Grosso do Sul</option>
                        <option value="MG">MG - Minas Gerais</option>
                        <option value="PA">PA - Pará</option>
                        <option value="PB">PB - Paraíba</option>
                        <option value="PR">PR - Paraná</option>
                        <option value="PE">PE - Pernambuco</option>
                        <option value="PI">PI - Piauí</option>
                        <option value="RJ">RJ - Rio de Janeiro</option>
                        <option value="RN">RN - Rio Grande do Norte</option>
                        <option value="RS">RS - Rio Grande do Sul</option>
                        <option value="RO">RO - Rondônia</option>
                        <option value="RR">RR - Roraima</option>
                        <option value="SC">SC - Santa Catarina</option>
                        <option value="SP">SP - São Paulo</option>
                        <option value="SE">SE - Sergipe</option>
                        <option value="TO">TO - Tocantins</option>
                      </TextField>
                    </WrapperInput>
                  </InputRow>

                  <WrapperInput>
                    <BoxMap>
                      {hasValidKey && position.latitude !== 0 && (
                        <Map
                          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${key}&v=3.exp&libraries=geometry,drawing,places`}
                          loadingElement={
                            <Center>
                              <Loading />
                            </Center>
                          }
                          containerElement={
                            <div
                              style={{
                                height: `250px`,
                                overflow: 'hidden',
                                borderRadius: '4px',
                              }}
                            />
                          }
                          mapElement={<div style={{ height: `100%` }} />}
                          position={position}
                        />
                      )}
                    </BoxMap>
                  </WrapperInput>
                </>
              )}
            </WrapperContent>
          </WrapperBody>
          {activeStep !== 0 && (
            <WrapperBottom>
              <Button
                label="Voltar"
                onClick={handleBack}
                type="button"
              />
            </WrapperBottom>
          )}
        </form>
      </Paper>
    </Container>
  );
}

export default ProviderForm;

